module.exports = __webpack_public_path__ + "media/images/flags/4x3/ala-afc5abc19ea2ffd3100579e55a6d9814.svg";